<template lang="pug">
  div(class='c-quantity')
    button(@click='less()' class='c-quantity__btn' type='button') -

    input(ref='quantity', type='number', :max='maxQuantity', :min='minQuantity'
    @input='handleChange($event)', :value='quantity', class='c-quantity__input', number)

    button(@click='more()' class='c-quantity__btn' type='button') +
</template>

<script>
  export default {
    props: {
      minQuantity: {
        type: [Number, String],
        default: 1
      },
      quantity: {
        type: [Number, String],
        required: true
      },
      less: {
        type: Function,
        default: () => {}
      },
      more: {
        type: Function,
        default: () => {}
      },
      newValue: {
        type: Function,
        default: () => {}
      }
    },
    methods: {
      handleChange (event) {
        let newValue = event.target.value
        if (newValue > this.minQuantity) {
          this.newValue(newValue)
        } else {
          this.newValue(this.minQuantity)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/InputQuantity.vue